import { Text } from '@chakra-ui/react'

import CustomTooltip from '../../CustomTooltip/CustomTooltip'

const TagWithoutTooltip = () => (
  <Text
    className="body-small-emphasis"
    paddingX="10px"
    paddingY="6px"
    borderRadius="full"
    backgroundColor="stone"
    color="white"
    data-testid="itListDetails-unlistedTag"
  >
    Unlisted
  </Text>
)

const UnlistedTag: React.FC<{
  creatorFirstName?: string
}> = ({ creatorFirstName }) => {
  if (creatorFirstName)
    return (
      <CustomTooltip
        label={`This ItList is hidden from ${creatorFirstName}’s public profile.`}
      >
        <TagWithoutTooltip />
      </CustomTooltip>
    )
  return <TagWithoutTooltip />
}
export default UnlistedTag
